import { IAppSettings } from "models";
import { ActionTypes } from "./actions";

export const appSettingsReducer = (state: IAppSettings, { payload, type }: { payload: any, type: ActionTypes } ) => {
    switch (type) {
		case ActionTypes.ShowInternalLinks:
			state.showInternalLinks = payload;
			return { ...state }
			
        default:
            return state
    }
}


